export default {
  topics (state) {
    return state.topics
  },
  isLoading (state) {
    return state.loading
  },
  isErr (state) {
    return state.err
  },
  page (state) {
    return state.page
  }
}



// WEBPACK FOOTER //
// ./src/store/home/getters.js